export default function toLowerCase(str) {
    if (!str || typeof str !== 'string')
        return undefined;
    return str.toLowerCase();
}
